import * as types from './constants';

// Get Lookbook Summary
export const getLookbookSummaryRequest = data => (
  { type: types.GET_LOOKBOOK_SUMMARY_REQUEST, payload: data }
);

export const getLookbookSummaryDone = data => (
  { type: types.GET_LOOKBOOK_SUMMARY_DONE, payload: data }
);

export const getLookbookSummaryFailed = errors => (
  { type: types.GET_LOOKBOOK_SUMMARY_FAILED, payload: errors }
);

export const getLookbookSummaryReset = () => (
  { type: types.GET_LOOKBOOK_SUMMARY_RESET }
);